export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const USER = '@irifei:user';
export const TOKEN = '@irifei:token';
